import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ViewportScroller } from '@angular/common';

import { takeUntil } from 'rxjs/operators';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { fromEvent, Observable, Subscription } from 'rxjs';

import {
  ChartioService,
  GetTokenAndURLResponse,
  GetTokenAndURLParams,
  Unsubscribe,
  MetricType,
} from 'src/app/core';

@Component({
  selector: 'app-chartio',
  templateUrl: './chartio.component.html',
  styleUrls: ['./chartio.component.less'],
})
export class ChartioComponent extends Unsubscribe implements OnInit {
  metricsUrl: SafeResourceUrl;
  @ViewChild('chartioIFrame') chartioIFrame: ElementRef<HTMLElement>;
  @Input() brandUuid: string;
  @Input() imsi: string;
  @Input() type: MetricType;

  HEIGHT_BUMPER = 75;
  chartioHeight = 1200;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  loadObservable$: Observable<Event>;
  loadSubscription$: Subscription;

  constructor(
    private domSanitzer: DomSanitizer,
    private chartioService: ChartioService,
    private viewportScroller: ViewportScroller,
    private scrollToService: ScrollToService
  ) {
    super();
  }

  ngOnInit(): void {
    this.triggerScrollTo();
    this.chartioHeight = window.innerHeight - this.HEIGHT_BUMPER;

    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((evt: any) => {
        this.chartioHeight = evt.target.innerHeight - this.HEIGHT_BUMPER;
      });

    this.runMetrics();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'brandUuid': {
            this.runMetrics();
          }
        }
      }
    }
  }

  runMetrics() {
    let param = {} as GetTokenAndURLParams;

    if (this.brandUuid) {
      if (this.type) {
        param.branduuid = this.brandUuid;
        param.type = this.type;
      } else {
        throw new Error('Must provide a Metric type with the branduuid');
      }
    } else if (this.imsi) {
      param.imsi = this.imsi;
    } else {
      throw new Error(
        'Must assign a branduuid or imsi input to component ChartioComponent'
      );
    }

    this.getTokenAndURL(param);
  }

  getTokenAndURL(param) {
    this.chartioService
      .getTokenAndURL(param)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: GetTokenAndURLResponse) => {
          this.metricsUrl = this.buildURL(res.base_url, res.token);
        },
        () => {
          // todo: handle error
        }
      );
  }

  triggerScrollTo() {
    const config: ScrollToConfigOptions = {
      target: 'chartio-iframe-target',
    };

    this.scrollToService
      .scrollTo(config)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (value: number) => {
          this.viewportScroller.scrollToPosition([0, value]);
        },
        (err) => console.error(err) // Error is caught and logged instead of thrown
      );
  }

  buildURL(baseURL: string, token: string): SafeResourceUrl {
    //github.com/angular/angular/blob/10.1.3/packages/platform-browser/src/security/dom_sanitization_service.ts#L135-L143
    https: return this.domSanitzer.bypassSecurityTrustResourceUrl(
      `${baseURL}?embed_token=${token}`
    );
  }
}
